export type TenantRequestStatus = 'p' | 'a' | 'r' | 'c'

export interface TenantRequest {
  id: string
  tenantCode: string
  tenantCodePrefix: string | null
  workspaceCode: string
  workspaceName: string
  partnerCode: string | null
  ownerEmail: string
  restoreFromTemplate: string | null // Template code (e.g., zea02, zea03) or null
  workspaceType: 'new' | 'demo' | 'trial' | 'uat'
  copyFromWorkspaceCode: string | null
  deactivationDate: string | null
  deactivationReason: string | null
  featureFlags: string[]
  licenseJsonb: string | null
  status: TenantRequestStatus
  requestedBy: string // Guid as string
  requestedByName: string | null
  requestedDate: string
  reviewedBy: string | null // Email or username
  reviewedDate: string | null
  reviewComments: string | null
  completedDate: string | null
  notes: string | null
}

export interface SubmitTenantRequestRequest {
  tenantCode?: string
  tenantCodePrefix?: string
  workspaceCode: string
  workspaceName: string
  partnerCode?: string
  ownerEmail: string
  restoreFromTemplate: string | null // Template code (e.g., zea02, zea03) or null
  workspaceType: 'new' | 'demo' | 'trial' | 'uat'
  copyFromWorkspaceCode?: string | null
  deactivationDate?: string | null
  deactivationReason?: string | null
  featureFlags: string[]
  licenseJsonb?: string
  notes?: string
}

export interface ReviewRequest {
  comments?: string
  notes?: string
}

export interface TenantRequestListResponse {
  data: TenantRequest[]
}

export const TenantRequestStatusLabels: Record<TenantRequestStatus, string> = {
  p: 'Pending',
  a: 'Approved',
  r: 'Rejected',
  c: 'Completed',
}

export const TenantRequestStatusColors: Record<TenantRequestStatus, string> = {
  p: 'blue',
  a: 'green',
  r: 'red',
  c: 'default',
}

export const WorkspaceTypeLabels: Record<string, string> = {
  new: 'New workspace',
  demo: 'Demo workspace',
  trial: 'Trial workspace',
  uat: 'UAT workspace',
}
